<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div
  class="flex flex-col min-h-lvh"
  [ngClass]="{
    'sm:min-h-auto': isCompactMinHeightLayout,
    'lg:min-h-auto': isProspectMinHeightLayout,
  }"
>
  <div
    class="flex flex-col flex-1"
    [ngClass]="{
      'sm:flex-none sm:min-h-lvh': isCompactMinHeightLayout,
      'lg:flex-none lg:min-h-lvh': isProspectMinHeightLayout,
    }"
  >
    @if (layout === Layout.DEFAULT_LAYOUT) {
      <myprofile-signup-ui-layout-default></myprofile-signup-ui-layout-default>
    } @else if (layout === Layout.PROSPECT_LAYOUT) {
      <myprofile-signup-ui-layout-prospect class="contents"></myprofile-signup-ui-layout-prospect>
    } @else if (layout === Layout.SUCCESS_LAYOUT) {
      <div class="flex flex-1">
        <myprofile-signup-ui-layout-success></myprofile-signup-ui-layout-success>
      </div>
    } @else if (layout === Layout.MAINTENANCE_LAYOUT) {
      <div class="overflow-hidden flex flex-1">
        <myprofile-signup-ui-layout-maintenance></myprofile-signup-ui-layout-maintenance>
      </div>
    }
  </div>
  <myprofile-signup-ui-footer></myprofile-signup-ui-footer>
</div>
